import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import moment from "moment";
import axios from "axios";
import Sidebar from "../Layout/Sidebar";
import CustomHeader from "../Layout/Header";



import { dataUser } from '../Helpers/util';
import wallelBalicon from './img/balance-icon-60x60.svg';
import CalendarIcon from './img/calendar-icon.svg';
import axiosInstance from '../../utils/axiosInstance';
import { Layout } from 'antd';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDTable from '../Common/AntDTable/AntDTable';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function PurchaseHistory({ }) {
    const [purchaseHistoryData, setPurchaseHistoryData] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [collapsed, setCollapsed] = useState(true);


    const getPurchaseHistory = () => {

        axiosInstance.get(
            `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/getCompanyWalletTopUps/${UserObj ? UserObj.company_id : null}/500`,

        ).then((res => {
            if (res.data.statusValue == 200)
                setPurchaseHistoryData(res.data.transactions);
            setSpinner(false);

        }))
    }

    useEffect(() => {
        getPurchaseHistory();
    }, []);
    ;


    const columns = [
        {
            title: "UTR",
            dataIndex: "transactionId",
            key: "transactionId",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => (
                <>
                    <i class="bi bi-calendar3" />
                    <span className='ms-2'>{date}</span> {/* date format unchanged */}
                </>
            ),
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (amount) => (
                <>
                    <img src={wallelBalicon} width="12px" /> {amount}
                </>
            ),
        },
    ];



    const handleExport = () => {
        const formattedData = purchaseHistoryData?.map(item => ({
            transactionId: item.transactionId,
            date: item.date,
            amount: item.amount,

        }));

        const headers = [
            { label: 'Date', key: 'date' },
            { label: 'Amount', key: 'amount' },
            { label: 'UTR', key: 'transactionId' }

        ];

        return { data: formattedData, headers, filename: 'PurchaseReport.csv' };
    };

    const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
    };


    return (
        <>
            <Layout>

                <Sidebar collapsed={collapsed} />

                <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />


                <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
                    <div className="PageContent">
                        <div className="row mb-3">
                            <div className="col-md-12">

                                <div className="row align-items-start justify-content-between">
                                    <div className="col-md-4">
                                        <div className='SwHeading'>
                                            <h2>Purchase Report</h2>
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-8">
                                        <div className="PageHead_Optons_Row">
                                            <ul className='PageHead_Optons_RightAligned'>
                                                <li>
                                                    {purchaseHistoryData.length > 0 ? (
                                                        <CSVLink {...handleExport()}>
                                                            <SwButton
                                                            variant="dark"
                                                            size="sm"
                                                            icon={<i className="bi bi-box-arrow-right"></i>}
                                                            iconPosition="start"
                                                            >
                                                            Export
                                                            </SwButton>
                                                        </CSVLink>
                                                        ) : (
                                                        <SwButton
                                                            variant="dark"
                                                            size="sm"
                                                            loading
                                                        >
                                                            Export
                                                        </SwButton>
                                                        )}

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <AntDTable
                                            columns={columns}
                                            dataSource={purchaseHistoryData}
                                            rowKey="transactionId"
                                            loading={spinner}
                                            pagination={false}
                                            clientSideSorting={false}
                                            size="small"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>
            </Layout>
        </>
    );
}

export default connect()(PurchaseHistory);
